/**
 * @generated SignedSource<<8ee010a62f49a8e50e68791f15780a93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type postiesSectionPrimaryContentItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink">;
  readonly " $fragmentType": "postiesSectionPrimaryContentItemContent";
};
export type postiesSectionPrimaryContentItemContent$key = {
  readonly " $data"?: postiesSectionPrimaryContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"postiesSectionPrimaryContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "postiesSectionPrimaryContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentCoverImageContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "6bad1b6a00cdb10a9a98574cc93524a8";

export default node;
